<template>
    <b-modal title="Automated Report Results"
    body-class="p-0"
     size="lg" hide-footer id="view-automated-report-results-modal">

        <div v-if="isLoading" class="text-center">
            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
        </div>

        <table v-if="!isLoading" class="table mb-0 table-centered">
            <thead class="thead-light">
                <tr>
                    <th>Description</th>
                    <th class="text-right"></th>
                    <!-- <th class="text-right">Actions</th> -->
                </tr>
            </thead>
            <tbody>
                <tr v-for="result in automatedReportResults" :key="`automated-report-result-${result.id}`">
                    <td>{{ result.filename }}</td>
                    <td class="text-right">
                        <router-link :to="`/automated-report-result/${result.id}`" class="btn btn-itg btn-sm">
                            Download
                        </router-link>
                    </td>
                </tr>
                <tr v-if="automatedReportResults.length === 0">
                    <th scope="row" colspan="2">
                        <span class="text-danger">No results</span>
                    </th>
                </tr>
            </tbody>
        </table>

    </b-modal>
</template>

<script>
import axios from 'axios';
import Forms from '../../../mixins/Forms';
export default {
    props: ['automatedReport'],
    data() {
        return {
            isLoading: false,
            serverErrors: [],
            automatedReportResults: []
        }
    },
    mixins: [Forms],
    watch: {
        automatedReport() {
            if (this.automatedReport) {
                this.loadAutomatedReportResults();
            } else {
                this.isLoading = false;
                this.automatedReportResults = [];
            }
        }
    },
    methods: {
        loadAutomatedReportResults() {
            let vm = this;
            vm.isLoading = true;
            vm.automatedReportResults = [];
            axios.get(API_BASE + '/automated-reports/' + vm.automatedReport.id + '/results/').then(r => {
                vm.isLoading = false;
                vm.automatedReportResults = r.data;
            }).catch(e => {
                console.log(e);
                vm.isLoading = false;
                vm.setErrors(e);
            });
        }
    },
}
</script>

<style></style>